"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationWrapper = exports.MobileLogo = exports.HeaderMenuMobileWrapper = exports.HeaderMenuWrapper = exports.HeaderWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _utilities = require("./utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderWrapper = _styledComponents.default.div.attrs({
  "data-qa": "header-wrapper"
}).withConfig({
  displayName: "CarvanaHeaderSkeletonstyles__HeaderWrapper",
  componentId: "w8sff5-0"
})(["box-shadow:1px 2px 3px 1px rgba(", ",0.1);margin:0 auto;max-width:", "px;position:relative;z-index:10;"], function (props) {
  return (0, _utilities.HexToRgb)(props.theme.carvana.blue.dark);
}, function (props) {
  return props.theme.breakpoints.values.xl;
});

exports.HeaderWrapper = HeaderWrapper;

var HeaderMenuWrapper = _styledComponents.default.div.attrs({
  "data-qa": "header-menu-wrapper"
}).withConfig({
  displayName: "CarvanaHeaderSkeletonstyles__HeaderMenuWrapper",
  componentId: "w8sff5-1"
})(["align-items:center;height:72px;padding:0 32px;display:none;background-color:", ";@media (min-width:", "px){display:flex;}"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.HeaderMenuWrapper = HeaderMenuWrapper;

var HeaderMenuMobileWrapper = _styledComponents.default.div.attrs({
  "data-qa": "header-menu-mobile-wrapper"
}).withConfig({
  displayName: "CarvanaHeaderSkeletonstyles__HeaderMenuMobileWrapper",
  componentId: "w8sff5-2"
})(["position:relative;align-items:center;display:flex;height:60px;padding:0 15px 0 10px;background-color:", ";@media (min-width:", "px){display:none;}"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.HeaderMenuMobileWrapper = HeaderMenuMobileWrapper;
var MobileLogo = (0, _styledComponents.default)(_Logo.default).withConfig({
  displayName: "CarvanaHeaderSkeletonstyles__MobileLogo",
  componentId: "w8sff5-3"
})(["&&{max-height:35px;max-width:155px;}"]);
exports.MobileLogo = MobileLogo;

var NavigationWrapper = _styledComponents.default.div.attrs({
  "data-qa": "navigation-wrapper"
}).withConfig({
  displayName: "CarvanaHeaderSkeletonstyles__NavigationWrapper",
  componentId: "w8sff5-4"
})(["position:relative;z-index:1;"]);

exports.NavigationWrapper = NavigationWrapper;